import script from "./ButtonSliding.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonSliding.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonSliding.vue?vue&type=style&index=0&id=90a0d4e0&scoped=true&lang=css"
import "./ButtonSliding.vue?vue&type=style&index=1&id=90a0d4e0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90a0d4e0"]])

export default __exports__